import React from "react";
import { CAlert } from "@coreui/react";

export default function ErrorAlert({ error, title = "Ошибка" }) {
  if (!error) return null;

  const msg =
    error?.response?.data?.message ||
    error?.message ||
    String(error);

  return (
    <CAlert color="danger">
      <strong>{title}:</strong> {msg}
    </CAlert>
  );
}

